import { base64ToInt16, int16ToFloat32 } from "./pcm";
import { LIVE_OUTPUT_SAMPLE_RATE } from "./protocol";

export class AudioPlayer {
  private context: AudioContext | null = null;
  private nextStartTime = 0;
  private activeSources = new Set<AudioBufferSourceNode>();

  private ensureContext(): AudioContext {
    if (!this.context) {
      this.context = new AudioContext({ sampleRate: LIVE_OUTPUT_SAMPLE_RATE });
      this.nextStartTime = this.context.currentTime;
    }
    return this.context;
  }

  playChunk(base64: string): void {
    const context = this.ensureContext();
    if (context.state === "suspended") void context.resume();

    const float32 = int16ToFloat32(base64ToInt16(base64));
    const buffer = context.createBuffer(1, float32.length, LIVE_OUTPUT_SAMPLE_RATE);
    buffer.copyToChannel(float32, 0);

    const source = context.createBufferSource();
    source.buffer = buffer;
    source.connect(context.destination);
    source.onended = () => this.activeSources.delete(source);

    const startAt = Math.max(this.nextStartTime, context.currentTime);
    source.start(startAt);
    this.nextStartTime = startAt + buffer.duration;
    this.activeSources.add(source);
  }

  interrupt(): void {
    for (const source of this.activeSources) {
      try {
        source.stop();
      } catch {
        // already stopped
      }
    }
    this.activeSources.clear();
    if (this.context) this.nextStartTime = this.context.currentTime;
  }

  close(): void {
    this.interrupt();
    void this.context?.close();
    this.context = null;
  }
}
